
export const restEndPoints = {
    shared : {
        getAllCategories:"api/shared/allCategories",
        getAllBookingSores:"api/shared/allStores",
        getAllBookingStatuses:"api/shared/allStatuses",
    },
    dashboard : {
        getAllTiles:"api/dashboard/dashboardDataTiles",
        getDashboardLeadFees:"api/dashboard/dashboardLeadFees",
        getDashboardBookings:"api/dashboard/dashboardBookings",
        getDashboardBookingStore:"api/dashboard/dashboardBookingsperStore",
        getDashboardBookingStorePercent:"api/dashboard/dashboardBookingsperStorePercentage",
        getLeebakkerdashboardBookingsCountPer :'api/dashboard/dashboardBookingsCountPer'
    },
    bookings :{
        getAllBookingData:"api/bookings/bookingsDetails",
        getBookingDetails:"api/bookings/bookingsData",
        getBookingSortingDetails:"api/bookings/bookingSortingDetails",
        getAllBookingDataCount:"api/bookings/bookingsDataCount",
        getBookingDetailsByTaskId:"api/bookings/bookingDetailsbyTaskid",
        getBookingsImagesByTaskId:"api/bookings/bookingsImagesbyTaskid",
    },
    reviews: {
        getReviewData:"api/reviews/reviewData",
        getReviewDataCount:"api/reviews/reviewsDataCount",
        getPercentileOfReviewByGrouped:"api/reviews/reviewsPercentageGroupedbyStore",
        getGridReviewDetails :"api/reviews/reviewDetails"
    },
    authentication:{
        changePassword:"api/auth/changePassword",
        resetPassword:"api/auth/forgotPassword",
        validateLogin:"api/auth/validateLogin",
        screenByOrg:"api/auth/companyList",
        auth:"api/auth/login"
    }

}

export const am5ChartLicense = "AM5C-9740-2435-6941-4469";
